import api from './api';

const BASE = '/job-offers';

export const JOB_OFFER_STATUSES = [
  { value: 'draft', label: 'Draft', color: 'default' },
  { value: 'pending_approval', label: 'Pending Approval', color: 'warning' },
  { value: 'approved', label: 'Approved', color: 'success' },
  { value: 'revision_requested', label: 'Revision Requested', color: 'info' },
  { value: 'rejected', label: 'Rejected', color: 'error' },
];

export function fetchJobOffers(params = {}) {
  return api.get(BASE, { params }).then((res) => res.data);
}

export function fetchJobOffer(id) {
  return api.get(`${BASE}/${id}`).then((res) => res.data?.data || res.data);
}

export function createJobOffer(payload) {
  return api.post(BASE, payload).then((res) => res.data?.data || res.data);
}

export function updateJobOffer(id, payload) {
  return api.put(`${BASE}/${id}`, payload).then((res) => res.data?.data || res.data);
}

export function deleteJobOffer(id) {
  return api.delete(`${BASE}/${id}`).then((res) => res.data);
}

export function submitJobOffer(id) {
  return api.post(`${BASE}/${id}/submit`).then((res) => res.data?.data || res.data);
}

export function approveJobOffer(id) {
  return api.post(`${BASE}/${id}/approve`).then((res) => res.data?.data || res.data);
}

export function requestRevision(id, reason) {
  return api
    .post(`${BASE}/${id}/request-revision`, { revision_reason: reason })
    .then((res) => res.data?.data || res.data);
}

export function rejectJobOffer(id, reason) {
  return api
    .post(`${BASE}/${id}/reject`, { rejection_reason: reason })
    .then((res) => res.data?.data || res.data);
}

export function previewCalculation(payload) {
  return api.post(`${BASE}/calculate`, payload).then((res) => res.data?.data || res.data);
}

export function jobOfferPdfUrl(id, variant = 'offer', { download = true } = {}) {
  const search = new URLSearchParams();
  search.set('variant', variant);
  if (download) search.set('download', '1');
  return `${BASE}/${id}/pdf?${search.toString()}`;
}

export async function downloadJobOfferPdf(id, variant = 'offer', filename = null) {
  const url = `${BASE}/${id}/pdf?variant=${variant}&download=1`;
  const res = await api.get(url, { responseType: 'blob' });
  const blob = new Blob([res.data], { type: 'application/pdf' });
  const link = document.createElement('a');
  const objectUrl = URL.createObjectURL(blob);
  link.href = objectUrl;
  link.download = filename || `job-offer-${id}-${variant}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(objectUrl);
}
